import React, { useState, useEffect } from 'react';
import { inventoryService } from '../../services/inventoryService';
import { FiPlus, FiEdit, FiTrash2, FiTruck, FiSearch } from 'react-icons/fi';

const SupplierList = () => {
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingSupplier, setEditingSupplier] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [formData, setFormData] = useState({ name: '', phone: '', email: '', address: '' });

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const data = await inventoryService.getSuppliers();
      console.log('📦 SupplierList data:', data); // ← LOG
      setSuppliers(data || []);
    } catch (error) {
      console.error('Error loading suppliers:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  if (!formData.name.trim()) {
    alert('Nama supplier wajib diisi');
    return;
  }

  try {
    let result; // ← DEKLARASIKAN DI SINI
    if (editingSupplier) {
      result = await inventoryService.updateSupplier(editingSupplier.id, formData);
    } else {
      result = await inventoryService.createSupplier(formData);
    }
    console.log('✅ Result:', result);
    setShowForm(false);
    setEditingSupplier(null);
    setFormData({ name: '', phone: '', email: '', address: '' });
    await loadData();
  } catch (error) {
    console.error('❌ Error:', error);
    alert('Error: ' + error.message);
  }
};

  const handleDelete = async (id) => {
    if (window.confirm('Hapus supplier ini?')) {
      try {
        await inventoryService.deleteSupplier(id);
        await loadData(); 
      } catch (error) {
        alert('Error: ' + error.message);
      }
    }
  };

  const handleEdit = (supplier) => {
    setEditingSupplier(supplier);
    setFormData({
      name: supplier.name || '',
      phone: supplier.phone || '',
      email: supplier.email || '',
      address: supplier.address || ''
    });
    setShowForm(true);
  };

  const filteredSuppliers = suppliers.filter(s =>
    s.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    s.phone?.includes(searchTerm) ||
    s.email?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return <div className="text-center py-8 text-[var(--text-secondary)]">Loading...</div>;
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold text-[var(--text-primary)]">Suppliers</h2>
        <button
          onClick={() => {
            setEditingSupplier(null);
            setFormData({ name: '', phone: '', email: '', address: '' });
            setShowForm(true);
          }}
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors"
        >
          <FiPlus /> Add Supplier
        </button>
      </div>

      {/* Search */}
      <div className="mb-4">
        <div className="relative">
          <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--text-secondary)]" size={16} />
          <input
            type="text"
            placeholder="Search suppliers..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-9 pr-3 py-1.5 text-sm border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)] focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>

      {/* Form */}
      {showForm && (
        <div className="bg-[var(--bg-secondary)] p-4 rounded-lg mb-4">
          <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-4 gap-3">
            <input
              type="text"
              placeholder="Nama Supplier *"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              className="px-3 py-1.5 text-sm border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)]"
              required
            />
            <input
              type="text"
              placeholder="Phone"
              value={formData.phone}
              onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
              className="px-3 py-1.5 text-sm border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)]"
            />
            <input
              type="email"
              placeholder="Email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              className="px-3 py-1.5 text-sm border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)]"
            />
            <input
              type="text"
              placeholder="Address"
              value={formData.address}
              onChange={(e) => setFormData({ ...formData, address: e.target.value })}
              className="px-3 py-1.5 text-sm border border-[var(--border-color)] rounded-lg bg-[var(--bg-primary)] text-[var(--text-primary)]"
            />
            <div className="flex gap-2 md:col-span-4">
              <button type="submit" className="px-4 py-1.5 text-sm bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors">
                {editingSupplier ? 'Update' : 'Save'}
              </button>
              <button
                type="button"
                onClick={() => { setShowForm(false); setEditingSupplier(null); }}
                className="px-4 py-1.5 text-sm bg-gray-500 hover:bg-gray-600 text-white rounded-lg transition-colors"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}

      {/* List */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {filteredSuppliers.length === 0 ? (
          <div className="col-span-full text-center py-8 text-[var(--text-secondary)]">
            <FiTruck size={40} className="mx-auto mb-2 opacity-50" />
            <p>No suppliers found</p>
          </div>
        ) : (
          filteredSuppliers.map((sup) => (
            <div key={sup.id} className="bg-[var(--bg-primary)] p-3 rounded-lg shadow-sm border border-[var(--border-color)] hover:shadow-md transition-shadow">
              <div className="flex justify-between items-start">
                <div>
                  <h3 className="font-semibold text-[var(--text-primary)]">{sup.name}</h3>
                  {sup.phone && <p className="text-xs text-[var(--text-secondary)]">📱 {sup.phone}</p>}
                  {sup.email && <p className="text-xs text-[var(--text-secondary)]">✉️ {sup.email}</p>}
                  {sup.address && <p className="text-xs text-[var(--text-secondary)]">📍 {sup.address}</p>}
                </div>
                <div className="flex gap-1">
                  <button onClick={() => handleEdit(sup)} className="p-1 text-yellow-600 hover:text-yellow-800 transition-colors" title="Edit">
                    <FiEdit size={15} />
                  </button>
                  <button onClick={() => handleDelete(sup.id)} className="p-1 text-red-600 hover:text-red-800 transition-colors" title="Delete">
                    <FiTrash2 size={15} />
                  </button>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default SupplierList;